module.exports = __webpack_public_path__ + "img/creative-commons-nd.85d15b72.svg";